import request from '@/core/request'
import { useRoute } from 'vue-router'
import { ref } from 'vue'

export const defaultConfig = {
  key: 'ui-record1',
  type: 'ui-record1',
  images: {
    // 支持多个tab的背景图
    recordBg: ['record-bg', 'record-bg'],
    recordOpenButton: 'record-open-button',
  }, // 每个组件的配置都统一放到images中管理
  layout: {
    recordWrapper: {
      pl: 344,
      pt: 535,
    },
    recordContentWrapper: {
      wh: '284 233',
      pc: 'x',
      pt: '83',
    },
    recordItemWrapper: {
      wh: '100% 36',
      mb: '4',
    },
    recordItemTextWrapper: {
      wh: '178 34',
      pl: '0',
      f: '12 #fff 400',
      lh: '17',
    },
    recordItemTimeWrapper: {
      wh: '60 34',
      pr: '0',
      f: '12 #fff 400',
      lh: '17',
    },
    recordItemDividerWrapper: {
      wh: '283 1',
      bgC: '#fff',
    },
  },
  config: {
    api: '/api/activities/general/lottery_record',
    componentIds: [1, 2],
    pageSize: 10,
    pageNum: 1,
    rewardDesc: `抽中了{reward_name}`,
  }, //每个ui组件的一些配置字段相关的东西
}

export const useRecord = (uiMeta: any) => {
  const route = useRoute()
  const activity_code = route.meta?.activity_code
  const componentIds = uiMeta.config?.componentIds
  const recordInfo = ref({
    loading: false,
    finished: false,
    list: [],
    pageSize: uiMeta.config.pageSize,
    pageNum: uiMeta.config.pageNum,
  })

  const setPageNum = () => {
    recordInfo.value.pageNum += 1
  }

  const recordLoad = async (active: number) => {
    if (recordInfo.value.loading) return

    if (recordInfo.value.finished) return

    recordInfo.value.loading = true
    const res = await request.get(uiMeta.config.api, {
      activity_code,
      component_id: componentIds[active],
      page_size: recordInfo.value.pageSize,
      page_num: recordInfo.value.pageNum,
    })
    recordInfo.value.list = recordInfo.value.list.concat(res.data?.rewards)
    recordInfo.value.finished = res.data?.rewards.length === 0

    if (!recordInfo.value.finished) {
      setPageNum()
    }
    recordInfo.value.loading = false
  }

  const clearData = () => {
    recordInfo.value.list = []
    recordInfo.value.pageNum = uiMeta.config.pageNum
    recordInfo.value.pageSize = uiMeta.config.pageSize
    recordInfo.value.loading = false
    recordInfo.value.finished = false
  }

  return {
    recordInfo,
    recordLoad,
    clearData,
  }
}
